import React from 'react';
import { Link } from 'react-router-dom';
export const Footer = () => {
  return <footer className="bg-gray-900 text-white pt-12 pb-6" data-id="element-93">
      <div className="container mx-auto px-4 lg:px-6" data-id="element-94">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8" data-id="element-95">
          {/* About */}
          <div data-id="element-96">
            <h2 className="text-xl font-bold mb-4" data-id="element-97">PROTOCOL</h2>
            <p className="text-gray-400 text-sm" data-id="element-98">
              Delivering accurate, unbiased news coverage from around the globe.
              Our mission is to inform, educate, and engage our readers.
            </p>
          </div>
          {/* Categories */}
          <div data-id="element-99">
            <h3 className="text-lg font-semibold mb-4" data-id="element-100">Categories</h3>
            <ul className="space-y-2 text-gray-400" data-id="element-101">
              <li data-id="element-102">
                <Link to="/category/politics" className="hover:text-white" data-id="element-103">
                  Politics
                </Link>
              </li>
              <li data-id="element-104">
                <Link to="/category/business" className="hover:text-white" data-id="element-105">
                  Business
                </Link>
              </li>
              <li data-id="element-106">
                <Link to="/category/technology" className="hover:text-white" data-id="element-107">
                  Technology
                </Link>
              </li>
              <li data-id="element-108">
                <Link to="/category/culture" className="hover:text-white" data-id="element-109">
                  Culture
                </Link>
              </li>
              <li data-id="element-110">
                <Link to="/category/world" className="hover:text-white" data-id="element-111">
                  World
                </Link>
              </li>
            </ul>
          </div>
          {/* Company */}
          <div data-id="element-112">
            <h3 className="text-lg font-semibold mb-4" data-id="element-113">Company</h3>
            <ul className="space-y-2 text-gray-400" data-id="element-114">
              <li data-id="element-115">
                <a href="#" className="hover:text-white" data-id="element-116">
                  About Us
                </a>
              </li>
              <li data-id="element-117">
                <a href="#" className="hover:text-white" data-id="element-118">
                  Contact
                </a>
              </li>
              <li data-id="element-119">
                <a href="#" className="hover:text-white" data-id="element-120">
                  Careers
                </a>
              </li>
              <li data-id="element-121">
                <Link to="/signup" className="hover:text-white" data-id="element-122">
                  Become a Reporter
                </Link>
              </li>
              <li data-id="element-123">
                <Link to="/login" className="hover:text-white" data-id="element-124">
                  Reporter Login
                </Link>
              </li>
              <li data-id="element-125">
                <a href="#" className="hover:text-white" data-id="element-126">
                  Advertise
                </a>
              </li>
              <li data-id="element-127">
                <a href="#" className="hover:text-white" data-id="element-128">
                  Ethics Policy
                </a>
              </li>
            </ul>
          </div>
          {/* Connect */}
          <div data-id="element-129">
            <h3 className="text-lg font-semibold mb-4" data-id="element-130">Connect</h3>
            <ul className="space-y-2 text-gray-400" data-id="element-131">
              <li data-id="element-132">
                <a href="#" className="hover:text-white" data-id="element-133">
                  Twitter
                </a>
              </li>
              <li data-id="element-134">
                <a href="#" className="hover:text-white" data-id="element-135">
                  Facebook
                </a>
              </li>
              <li data-id="element-136">
                <a href="#" className="hover:text-white" data-id="element-137">
                  Instagram
                </a>
              </li>
              <li data-id="element-138">
                <a href="#" className="hover:text-white" data-id="element-139">
                  LinkedIn
                </a>
              </li>
              <li data-id="element-140">
                <a href="#" className="hover:text-white" data-id="element-141">
                  YouTube
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 pt-6 mt-6" data-id="element-142">
          <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-143">
            <p className="text-gray-500 text-sm" data-id="element-144">
              © 2023 Protocol. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-145">
              <a href="#" className="text-gray-500 hover:text-white text-sm" data-id="element-146">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-500 hover:text-white text-sm" data-id="element-147">
                Terms of Service
              </a>
              <a href="#" className="text-gray-500 hover:text-white text-sm" data-id="element-148">
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
};